import React from 'react'
import _ from 'lodash'
import axios from 'axios'
import immutable from 'immutable'
import classNames from 'classnames'

import {LunaLoader} from '../widgets/lunaloader/lunaloader.component'

import {FlashMessages} from '../widgets/flashmessages.component'
import {AccommodationList} from '../accommodations/accommodationlist.component'
import {ActivityList} from '../activities/activitylist.component'
import {TravelList} from '../travel/travellist.component'
import {ImageThumb} from '../widgets/layout/imagethumb.component'
import {ItemOverviewBlock} from '../widgets/layout/itemoverviewblock.component'
import {LunaMapBox} from '../widgets/lunamapbox.component'
import {LunaHints} from '../widgets/lunahints.component'
import {LunaConfirm} from '../widgets/lunaconfirm.component'

import legUtil from '../util/leg.util'
import cookieUtil from '../util/cookie.util'

import QuickChat from '../widgets/chat/quickchat.container'
import {ImageGrid} from '../widgets/imagegrid.component'

const LUNA_TRIP_API = '/api/v1/trips/luna-trips'

export class ItineraryOverview extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            lunaLoaded: false,
            lunaImages: [],
            lunaPins: []
        }

        this.loadPartnerFeatures()

        let self = this

        if (this.props.isLunaTrip) {
            // Filter to get only legs with valid destinations
            let validLegs = this.props.legs.filter(function (leg) {
                return leg.getIn(['destination', 'id']) !== -1
            })

            // Get the id's of those destinations
            let destIds = validLegs.map(function (leg) {
                return leg.getIn(['destination', 'id'])
            }).join(',')

            let destPins = validLegs.map(function (leg) {
                return {
                    leg_id: leg.get('id'),
                    destination: leg.getIn(['destination', 'title']),
                    longitude: leg.getIn(['destination', 'location', 'longitude']),
                    latitude: leg.getIn(['destination', 'location', 'latitude'])
                }
            })

            let params
            if (this.props.lunatrip.get('slideshow')) {
                params = {
                    slideshow: this.props.lunatrip.get('slideshow')
                }
            } else {
                params = {
                    ids: destIds,
                    limit: 15
                }
            }
            axios.get('/api/v1/destinations/images/', {
                params: params
            }).then(function (response) {
                if (response.data !== undefined) {
                    self.setState({
                        lunaLoaded: true,
                        lunaImages: immutable.fromJS(response.data.results),
                        lunaPins: destPins
                    })
                } else {
                    console.log('ERROR: in fetching luna trip images')
                    console.log(response)
                }
            })
        }

        _.bindAll(this,
            'mobileAddDestination',
            'getLegs',
            'reservationCheck',
            'toggleActive',
            'getLunaTripHelp'
        )
    }

    loadPartnerFeatures() {
        let fromLunaTrip = this.props.fromLunaTrip
        if (!fromLunaTrip) {
            return
        }
        let url = `${LUNA_TRIP_API}/${fromLunaTrip}/`
        let self = this
        axios.get(url).then((response) => {
            self.setState({lunaTrip: immutable.fromJS(response.data)})
        })
    }

    componentWillMount() {
        // expecting leg, section, subsection, detail
        this.props.updateDetailSections(null, this.props.availableDetailSections.DESTINATION, this.props.availableDetailSubSections.OVERVIEW)
    }

    mobileAddDestination() {
        // We don't have visual access to the planner, so first see if there is an empty leg at the end of the list already
        if (this.props.lastLeg.getIn(['destination', 'id']) === -1) {
            // console.log('last leg doesnt have a destination')
            this.props.onActivateLeg(this.props.lastLeg)
        } else {
            // Else, can we fit another leg in the timeline?
            if (Math.ceil(this.props.lastLeg.getIn(['properties', 'end'])) < this.props.totalDays) {
                // console.log('we can fit a leg in existing timeframe so add one')
                this.props.onAddLeg(this.props.lastLeg.getIn(['properties', 'end']), 1)
            } else {
                // console.log('cant fit it, add a day, then add the leg')
                this.props.onAppendDayAndLeg(this.props.lastLeg.getIn(['properties', 'end']), 1)
            }
        }
    }

    updateDetailTravelStatuses(leg, detailSubDetail) {
        this.props.updateDetailSections(leg, this.props.availableDetailSections.TRAVEL, this.props.availableDetailSubSections.SEARCH, detailSubDetail)
    }


    getTravelOrigin(leg) {
        // First leg, we'll place the origin if set
        let origin = this.props.originDestination ? this.props.originDestination.getIn(['destination', 'title']) :
        <span>Origin City</span>
        return (
            <div className="travel-block origin-city">
                <div
     onClick={() => this.updateDetailTravelStatuses(leg, this.props.availableDetailSubDetails.ARRIVAL) }>
                    {origin}
                </div>
                <i className="icon-arrow_right_a"/>
                <div
     onClick={() => this.updateDetailTravelStatuses(leg, this.props.availableDetailSubDetails.ARRIVAL) }>
                    { leg.getIn(['destination', 'title']) }
                </div>
            </div>
        )
    }

    getTravel(leg, index) {
        let nextLeg = legUtil.getNextByLeg(this.props.legs, leg)

        // lif no next leg, this is the last leg, check for return city
        if (!nextLeg || nextLeg.getIn(['destination', 'id']) === -1) {
            let returnCity = this.props.returnDestination ? this.props.returnDestination.getIn(['destination', 'title']) :
            <span>Return City</span>
            return (
                <div className="travel-block return-city">
                    <div
      onClick={() => this.updateDetailTravelStatuses(leg, this.props.availableDetailSubDetails.DEPARTURE) }>
                        { leg.getIn(['destination', 'title']) }
                    </div>
                    <i className="icon-arrow_right_a"/>
                    <div
      onClick={() => this.updateDetailTravelStatuses(leg, this.props.availableDetailSubDetails.DEPARTURE) }>
                        { returnCity }
                    </div>
                </div>
            )
        } else {
            return (
                <div className="travel-block between-city">
                    <div
      onClick={() => this.updateDetailTravelStatuses(leg, this.props.availableDetailSubDetails.DEPARTURE) }>
                        { leg.getIn(['destination', 'title']) }
                    </div>
                    <i className="icon-arrow_right_a"/>
                    <div
      onClick={() => this.updateDetailTravelStatuses(nextLeg, this.props.availableDetailSubDetails.ARRIVAL) }>
                        { nextLeg.getIn(['destination', 'title']) }
                    </div>
                </div>
            )
        }
    }

    reservationCheck(leg) {
        let accomRes = leg.get('accommodations').filter((accom) => {
            if (accom.getIn(['reservation_details', 'confirmation_code'])) {
                return true
            } else {
                return false
            }
        })
        let actRes = leg.get('activities').filter((act) => {
            if (act.getIn(['reservation_details', 'confirmation_code'])) {
                return true
            } else {
                return false
            }
        })
        let travelRes = leg.get('transportation').filter((trans) => {
            if (trans.getIn(['reservation_details', 'confirmation_code'])) {
                return true
            } else {
                return false
            }
        })

        if (accomRes.size > 0 || actRes.size > 0 || travelRes.size > 0) {
            return (
                <div className="itin-body-snippet-block active no-hover">
                    <i className="icon-reservation"/> {accomRes.size + actRes.size + travelRes.size}
                </div>
            )
        } else {
            return (
                <div className="itin-body-snippet-block no-hover">
                    <i className="icon-reservation"/> -
                </div>
            )
        }
    }

    toggleActive(refIndex) {
        document.getElementById('itinerary-item-' + refIndex.index).classList.toggle('active')
    }

    getLegs() {
        let validLegs = this.props.legs.filter(function (leg) {
            if (leg.getIn(['destination', 'id']) === -1) {
                return false
            } else {
                return true
            }
        })

        let allLegs = validLegs.map((leg, index) => {
            let legTransportation = this.props.allTransportation.filter((transportation) => {
                if (transportation.getIn(['legDep']) === leg.getIn(['id']) || transportation.getIn(['legArr']) === leg.getIn(['id'])) {
                    return true
                } else {
                    return false
                }
            })
            let origBlock = null
            if (index === 0) {
                origBlock = <div className="view-area">
                    <div className="view-left-col nopad-bt"/>
                    <div className="view-center nopad-bt">
                        {this.getTravelOrigin(leg)}
                    </div>
                    <div className="view-right-col nopad-bt"/>
                </div>
            }

            let accommodationBlock = leg.get('accommodations').size > 0 ?
                <AccommodationList {...this.props} leg={leg}/> : null
            let activityBlock = leg.get('activities').size > 0 ? <ActivityList {...this.props} leg={leg}/> : null
            let travelBlock = leg.get('transportation').size > 0 ?
                <TravelList {...this.props} leg={leg} transportation={legTransportation}/> : null

            let accomClass = classNames('itin-body-snippet-block', {'active': leg.getIn(['accommodations']).size > 0})
            let actClass = classNames('itin-body-snippet-block', {'active': leg.getIn(['activities']).size > 0})
            let travelClass = classNames('itin-body-snippet-block', {'active': leg.getIn(['transportation']).size > 0})

            let favoriteIcon = null
            if (leg.getIn(['accommodations']).size > 0 || leg.getIn(['activities']).size > 0 || leg.getIn(['transportation']).size > 0) {
                favoriteIcon = <i className="icon-favorite" onClick={() => {
                    this.toggleActive({index})
                } }/>
            }

            return (
                <div key={index} id={'itinerary-item-' + index} className="itinerary-item">
                    {origBlock}
                    <div className="view-area">
                        <div className="view-left-col"/>
                        <div className="view-center">
                            <div className="itinerary-item-header">
                                <ImageThumb item={leg.get('destination')} model="destination" type="overview-list"
                                            showDetails={() => this.props.updateDetailSections(leg, this.props.availableDetailSections.DESTINATION, this.props.availableDetailSubSections.OVERVIEW)}/>
                                <div className="itin-body">
                                    <h1 onClick={() => this.props.updateDetailSections(leg, this.props.availableDetailSections.DESTINATION, this.props.availableDetailSubSections.OVERVIEW)}>{leg.getIn(['destination', 'title'])}</h1>
                                    <div className="itin-dest-description">
                                        { leg.getIn(['destination', 'description', 'excerpt']) || leg.getIn(['destination', 'excerpt']) }
                                    </div>
                                    <div className="itin-body-snippet">
                                        <div
           onClick={() => this.props.updateDetailSections(leg, this.props.availableDetailSections.ACCOMMODATIONS, this.props.availableDetailSubSections.OVERVIEW)}
           className={accomClass}>
                                            <i className="icon-hotel"/> { leg.getIn(['accommodations']).size > 0 ? leg.getIn(['accommodations']).size : '-'}
                                        </div>
                                        <div
           onClick={() => this.props.updateDetailSections(leg, this.props.availableDetailSections.ACTIVITIES, this.props.availableDetailSubSections.OVERVIEW)}
           className={actClass}>
                                            <i className="icon-bicycle"/> { leg.getIn(['activities']).size > 0 ? leg.getIn(['activities']).size : '-'}
                                        </div>
                                        <div
           onClick={() => this.props.updateDetailSections(leg, this.props.availableDetailSections.TRAVEL, this.props.availableDetailSubSections.OVERVIEW)}
           className={travelClass}>
                                            <i className="icon-plane_right"/> { leg.getIn(['transportation']).size > 0 ? leg.getIn(['transportation']).size : '-'}
                                        </div>
                                        {this.reservationCheck(leg)}
                                    </div>
                                </div>
                                <div className="itin-tools">
                                    <LunaConfirm type="iconDelete" onConfirm={() => {
                                        this.props.onDeleteLeg(leg)
                                    }} mssg="Are you sure you want to delete this leg?"/>
                                    <QuickChat {...this.props} leg={leg} targetItem={leg.getIn(['destination'])}
                                               targetItemType='destination'/>
                                    {favoriteIcon}
                                </div>
                            </div>
                        </div>
                        <div className="view-right-col"/>
                    </div>
                    <div className="itinerary-item-favorites">
                        {accommodationBlock}
                        {activityBlock}
                        {travelBlock}
                    </div>
                    <div className="view-area">
                        <div className="view-left-col nopad-bt"/>
                        <div className="view-center nopad-bt">
                            { this.getTravel(leg, index) }
                        </div>
                        <div className="view-right-col nopad-bt"/>
                    </div>
                </div>
            )
        })
        if (validLegs.size > 0) {
            if (!window._isMobile) {
                return (
                    <div>
                        {allLegs}
                        <div className="view-area">
                            <div className="view-left-col"/>
                            <div className="view-center">
                                <div className="section-title">
                                    <h1>Using the Planner Tool</h1>
                                    <p>A few friendly tips to help you navigate your trip.</p>
                                </div>
                                <LunaHints/>
                            </div>
                            <div className="view-right-col"/>
                        </div>
                    </div>
                )
            } else {
                // this is mobile
                return (
                    <div>
                        {allLegs}
                    </div>
                )
            }
        } else {
            return (
                <div className="view-area">
                    <div className="view-left-col"/>
                    <div className="view-center">
                        <div className="section-title">
                            <h1>Let’s get started with your destinations.</h1>
                            <p>Select a day block from the planner above to get started.</p>

                        </div>
                        <LunaHints/>
                    </div>
                    <div className="view-right-col"/>
                </div>
            )
        }
    }

    getImages(title) {
        return <ImageGrid images={this.state.lunaImages} title={title}/>
    }

    closeLunaTripHelp() {
        $('.luna-trip-help-block').fadeOut(300, function () {
            // hide the block and then set cookie (name, value, days)
            cookieUtil.createCookie('dismissLunaTripHelp', true, 60)
            $(this).remove()
        })
    }

    getLunaTripHelp() {
        // TODO: check for cookie
        let hasCookie = cookieUtil.readCookie('dismissLunaTripHelp')
        if (!hasCookie && !window._isMobile) {
            return (
                <div className="luna-trip-help-block flex-row">
                    <i className="btn-close icon-close" onClick={() => {this.closeLunaTripHelp()} }/>
                    <div className="luna-trip-help-content">
                        <h1>Welcome to Luna!</h1>
                        <p>
							Explore our sample itinerary including hand-picked suggestions for hotels, activities,
							dining and more. The entire trip is customizable, so make the trip your own with our
							easy-to-use planning tools. To learn how to get started, click the "View Tutorial" button.
							Happy travels!
                        </p>
                    </div>
                    <div className="btn" onClick={() => {this.props.onToggleHelp('luna-trip', true)} }>VIEW TUTORIAL</div>
                </div>
            )
        } else {
            return null
        }
    }

    getContent() {
        if (this.props.isLunaTrip) {
            if (this.state.lunaLoaded) {
                let lunaDesc = this.props.lunatrip.get('description')
                let lunaHighlights = $('<div />').html(this.props.lunatrip.get('highlights')).text()
                let lunaPins = this.state.lunaPins
                let lunaTripBlocks = this.props.lunatrip.get('blocks')
                let lunaTripLookBook = lunaTripBlocks.get('lookBook')
                let lunaTripTitleBlock = lunaTripBlocks.get('title')
                let lunaTripQuote = lunaTripBlocks.get('quote')
                let blockImages = this.props.lunatrip.get('blocks_images')
                let blockContentImages = null
                if (lunaTripLookBook && lunaTripLookBook.get('contentImages')) {
                    blockContentImages = lunaTripLookBook.get('contentImages').map((contentImage, index) =>
                        <a key={index} href={contentImage.get('link')} target="_blank">
                            <img width="260" src={blockImages.get(contentImage.get('id')).get('image_url')}
                                 alt={blockImages.get(contentImage.get('id')).get('alt')}/>
                        </a>
                    )
                }

                return (
                    <div>
                        <div className="view-area">
                            <div className="view-left-col nopad-bt"/>
                            <div className="view-center nopad-bt">
                                {(!lunaTripTitleBlock || lunaTripTitleBlock.get('showTutorialBox') !== false) && this.getLunaTripHelp()}
                                <h1 id="dest-name" style={{'marginTop': '1em'}}>{this.props.lunatrip.get('name')}</h1>
                                {lunaTripTitleBlock && lunaTripTitleBlock.get('designedByImageId') &&
                                <h3 className="text-center luna-trip-subtitle" style={{'marginTop': '0'}}>a trip designed by <img className="subtitle-image" src={blockImages.get(lunaTripTitleBlock.get('designedByImageId')).get('image_url')} alt={blockImages.get(lunaTripTitleBlock.get('designedByImageId')).get('image_url')}/></h3>
                                }
                                {this.getImages(this.props.lunatrip.get('name'))}
                                <ItemOverviewBlock label='Overview' body={ lunaDesc }/>
                                {lunaTripQuote &&
                                <div className="row">
                                    <div className="col-sm-12 trip-quote-block top-separator text-center">
                                        <p className="trip-quote-text">“{lunaTripQuote.get('text')}”</p>
                                        <span className="trip-quote-signature pull-right">{lunaTripQuote.get('signature')}</span>
                                    </div>
                                </div>
                                }
                                <LunaMapBox pins={ lunaPins }/>
                                <ItemOverviewBlock label='Highlights' body={ lunaHighlights }/>
                            </div>
                            <div className="view-right-col nopad-bt"/>
                        </div>
                        {lunaTripLookBook && lunaTripLookBook.get('titleImageId') &&
                        <div className="view-area">
                            <div className="view-left-col nopad-bt"/>
                            <div className="view-center partner-lookbook" style={{'borderColor': lunaTripLookBook.get('primaryColor')}}>
                                <h1 style={{'color': lunaTripLookBook.get('primaryColor')}}>{lunaTripLookBook.get('title')}</h1>
                                <img className="subtitle-image" src={blockImages.get(lunaTripLookBook.get('titleImageId')).get('image_url')} alt={blockImages.get(lunaTripLookBook.get('titleImageId')).get('image_url')}/>
                                <p>{lunaTripLookBook.get('excerpt')}</p>
                                <div className="content-images">
                                    {blockContentImages}
                                </div>
                                <a className="btn" href={lunaTripLookBook.get('buttonLink')} target="_blank">{lunaTripLookBook.get('buttonText')}</a>
                            </div>
                            <div className="view-right-col nopad-bt"/>
                        </div>
                        }
                        <div>
                            { this.getLegs() }
                        </div>
                    </div>
                )
            } else {
                return (<LunaLoader style="basic"/>)
            }
        } else {
            let fromLunaTrip = this.props.fromLunaTrip
            let designedByLogo = null
            let link = null
            if (fromLunaTrip && this.state.lunaTrip) {
                link = `/itineraries/honeymoons/${fromLunaTrip}/`
                let images = this.state.lunaTrip.get('blocks_images')
                designedByLogo = images.get(this.state.lunaTrip.getIn(['blocks', 'title', 'designedByImageId']))
            }
            return (
                <div>
                    {fromLunaTrip && designedByLogo &&
                    <div className="view-area">
                        <div className="view-left-col nopad-bt"/>
                        <div className="view-center nopad-bt">

                            <h3 className="text-center luna-trip-subtitle" style={{'marginTop': '0'}}>
                                Inspired by a <a href={link} target="_blank">trip</a> designed by <img className="subtitle-image" src={designedByLogo.get('image_url')} alt={designedByLogo.get('alt')}/>
                            </h3>
                        </div>
                        <div className="view-right-col nopad-bt"/>
                    </div>
                    }
                    <div className="view-area">
                        <div className="view-left-col nopad-bt"/>
                        <div className="view-center nopad-bt">
                            {this.getLunaTripHelp()}
                        </div>
                        <div className="view-right-col nopad-bt"/>
                    </div>
                    <div>
                        { this.getLegs() }
                    </div>
                </div>
            )
        }
    }

    render() {
        let addDestinationBtn = null
        if (window._isMobile) {
            addDestinationBtn =
                <div id="add-dest-btn" className="btn btn-medium" onClick={this.mobileAddDestination}>Add a
					Destination</div>
        }
        return (
            <div className="itinerary-view">
                {addDestinationBtn}
                <FlashMessages/>
                {this.getContent()}
            </div>
        )
    }
}// this.props.onDeleteLeg(leg)
